import React, { ReactNode } from 'react';
import styled from 'styled-components';
import { COLOR } from '../../styles/colors';
import Font from '../../styles/font';
import StyledButton, { ButtonFill, ButtonTheme } from '../Button/StyledButton';
import Text from '../Text/StyledText';

export const StyledTablePlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;

  .action-container {
    margin-top: 16px;
  }
`;

export const StyledTablePlaceholderButton = styled(StyledButton).attrs({
  $fillMode: ButtonFill.Outline,
  $colorScheme: ButtonTheme.Theme
})``;

export interface ITablePlaceholderProps {
  header?: string;
  subheader?: ReactNode;
  action?: any;
  className?: string;
}

const TablePlaceholder: React.FC<ITablePlaceholderProps> = ({
  header = 'No Data',
  subheader = 'There is no data to display.',
  action,
  className
}) => (
  <StyledTablePlaceholder className={className}>
    <Text className={Font.f16_bold_tall}>{header}</Text>
    <Text as="p" $color={COLOR.neutral60}>
      {subheader}
    </Text>
    {action && <div className="action-container">{action}</div>}
  </StyledTablePlaceholder>
);

export default TablePlaceholder;
